// src/config/toolProcessingMessages.ts

/**
 * Rotating messages shown during tool processing (auto-redline).
 * Conversational tone for document editing operations.
 * Generic context - no specific document types (MSA, SoW, SaaS, NDA).
 */
export const TOOL_PROCESSING_MESSAGES = [
  "Working on your edits...",
  "Getting your changes ready...",
  "Putting together the revisions...",
  "Applying your suggestions...",
  "Working through the changes...",
  "Getting everything in order...",
  // Active work verbs
  "Crafting your revisions...",
  "Preparing the markup...",
  "Processing your requests...",
  "Building out the edits...",
  // Review/analysis focused
  "Reviewing the details...",
  "Analyzing the sections...",
  "Looking over the language...",
  // Document manipulation
  "Adjusting the wording...",
  "Refining the text...",
  "Shaping the content...",
  "Organizing the changes...",
  // Progress-oriented
  "Moving through the revisions...",
  "Handling your updates...",
] as const;

/**
 * Rotating messages shown while the add_comment_tool is executing.
 * Conversational tone for preparing an inline document comment.
 */
export const ADD_COMMENT_PROCESSING_MESSAGES = [
  "Adding a comment...",
  "Drafting the comment...",
  "Preparing the annotation...",
  "Writing up the note...",
  "Pinpointing the right spot...",
  "Putting the comment together...",
] as const;

// Rotation interval in milliseconds (~5 seconds)
export const TOOL_MESSAGE_ROTATION_MS = 4800;
